import i18n from '../../language/index'
import linkData from '@/base/linkData'
import img_effects from '@/base/img_effects'
import {create_title} from './../../base/titleData'

export default {
  img_effects,
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor: {
    marginTop: '0%',
    marginLeft: '0%',
    marginRight: '0%',
    marginBottom: '0%',
    textAlign: 'center'
  },
  mb_infor: {
    marginTop: '2.666%',
    marginRight: '3.733%',
    marginBottom: '1.333%',
    marginLeft: '3.733%',
    textAlign: 'center'
  },
  pc_widgets_infor: {
    height: 30,
    title: create_title(i18n.t('widgets_basic_notice_style_2724')),
    marginTop: '2.666%',
    marginLeft: '3.733%',
    marginRight: '3.733%',
    marginBottom: '1.333%',
    textAlign: 'center',
    direction: 'left',
    roll_speed: 5,
    roll_way: 'in',
    roll_loop: true,
    roll_wait: 3,
    noticeImgVisible: 'custom',
    borderRadius: {
      radio_val: 'default',
      default: {
        value: 0,
      },
      custom: {
        value: 0,
      }
    },
    background: {
      radio_val: 'default',
      default: {
        color: 'rgba(255,255,255,0)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255,255,255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    border: {
      radio_val: 'default',
      default: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        borderBottomWidth: 0,
        borderStyle: 'solid',
        borderColor: "rgba(255, 255, 255,1)",
        borderSeColor: "rgba(0, 0, 0,1)",
        checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
      },
      custom: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        borderBottomWidth: 0,
        borderStyle: 'solid',
        borderColor: "rgba(255, 255, 255,1)",
        borderSeColor: "rgba(0, 0, 0,1)",
        checkList: ['borderTopWidth', 'borderLeftWidth'],
      }
    },
    font: {
      radio_val: 'default',
      default: {
        fontStyle: '',
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(0,0,0,1)',
        fontSeColor: 'rgba(255,255,255,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fontStyle: '',
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(0,0,0,1)',
        fontSeColor: 'rgba(255,255,255,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    }
  },
  mb_widgets_infor: {},
  listArr: {
    link: linkData,
    noticeWords: i18n.t('widgets_basic_notice_edit_2718'),
    noticeImg: 'https://staticjs.71360.com/static/txys-001/image/icon_notice_type_1.gif',
    noticeImgType: 'type_1'
  },
};



// WEBPACK FOOTER //
// ./src/widgets/basic_notice/style.js